// The amount of time before logout due to inactivity: 20 minutes
export const ACTIVITY_LOGOUT_TIME = 1200000;
// Refresh token expire time: 5 minutes
// Refresh token api call time: 4 mins
export const REFRESH_TOKEN_TIME = 1000 * 60 * 4;